import { displayName } from "./userDisplay";

/**
 * One line of prose per thread event — shared by the task thread and the
 * per-agent feed so "scout released their claim — the task closed" reads
 * the same everywhere. Status codes map to the board's labels.
 */
export const STATUS_LABEL = {
  TODO: "TODO",
  IN_PROGRESS: "In Progress",
  BLOCKED: "Blocked",
  DONE: "Done",
  CANCELED: "Canceled",
};
export const statusLabel = (value) => STATUS_LABEL[value] || value || "?";

/** One line of prose per event; comments render their body as-is (text). */
export const describeEvent = (event) => {
  const p = event.payload || {};
  switch (event.verb) {
    case "created":
      return "created this task";
    case "status_changed":
      return `moved it from ${statusLabel(p.from)} to ${statusLabel(p.to)}`;
    case "assigned":
      if (p.to) return `assigned it to ${displayName(p.to)}`;
      return p.from
        ? `unassigned ${displayName(p.from)}`
        : "cleared the assignee";
    case "claimed":
      return "claimed it";
    case "released": {
      // payload.reason is the API's ReleaseReason enum: released | closed | lost_sight
      const holder = p.by ? displayName(p.by) : "";
      const own = holder && p.by?.id === event.actor?.id;
      const whose = own
        ? "their claim"
        : holder
          ? `${holder}'s claim`
          : "the claim";
      if (p.reason === "closed") return `released ${whose} — the task closed`;
      if (p.reason === "lost_sight")
        return `released ${whose} — ${holder || "they"} can no longer see it`;
      if (p.reason === "deactivated")
        return `released ${whose} — ${holder || "the agent"} was deactivated`;
      return `released ${whose}`;
    }
    case "archived":
      return p.reason === "auto"
        ? "archived it — it had been finished for a while"
        : "archived it";
    case "unarchived":
      return p.reason === "reopened"
        ? "restored it from the archive — the task was reopened"
        : "restored it from the archive";
    case "attached":
      return `attached ${p.name || "a file"}`;
    case "detached":
      return `removed ${p.name || "a file"}`;
    case "drawing_linked":
      return p.title
        ? `linked the drawing “${p.title}”`
        : "linked a private drawing";
    case "drawing_unlinked":
      if (p.count > 1) return `unlinked ${p.count} private drawings`;
      return p.title
        ? `unlinked the drawing “${p.title}”`
        : "unlinked a private drawing";
    case "comment":
      return null;
    default:
      return event.verb;
  }
};
